<template>
  <s-form @submit="saveGathering">
    <fieldset class="m-form-fieldset m-form-fieldset--no-margin">
      <div class="h-grid h-grid--justify-content-center h-grid--row-gutter">
        <div class="h-grid__col h-grid__col--sm-10 h-grid__col--md-8">
          <p class="m-form-group">
            <label class="a-form-label" for="organizerName">
              {{ $t('label-edit-gathering-organizerName') }}<required-form-field /><span class="m-form-group__note m-form-group__note--small">{{
                $t('label-edit-gathering-public-information')
              }}</span></label
            >
            <input class="a-form-control" id="organizerName" v-model.trim="$v.organizerName.$model" autocomplete="edit-gathering organizer-name" />
            <span v-if="$v.organizerName.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizerName.required">{{ $t('error-field-required') }}</span>
            </span>
          </p>

          <p class="m-form-group">
            <label class="a-form-label" for="organizationName">
              {{ $t('label-edit-gathering-organizationName') }}<required-form-field /><span class="m-form-group__note m-form-group__note--small">{{
                $t('detail-label-edit-gathering-organizationName')
              }}</span></label
            >
            <input class="a-form-control" id="organizationName" v-model.trim="$v.organizationName.$model" autocomplete="edit-gathering organization-name" />
            <span v-if="$v.organizationName.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizationName.required">{{ $t('error-field-required') }}</span>
            </span>
          </p>

          <p class="m-form-group">
            <label class="a-form-label" for="organizerEmail">
              {{ $t('label-edit-gathering-organizerEmail') }}<required-form-field /><span class="m-form-group__note m-form-group__note--small">{{
                $t('label-edit-gathering-public-information')
              }}</span></label
            >
            <input class="a-form-control" id="organizerEmail" v-model.trim="$v.organizerEmail.$model" autocomplete="edit-gathering organizer-email" />
            <span v-if="$v.organizerEmail.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizerEmail.required">{{ $t('error-field-required') }}</span>
              <span class="m-form-group__error" v-if="!$v.organizerEmail.email">{{ $t('error-field-not-email') }}</span>
            </span>
          </p>

          <p class="m-form-group">
            <googlemap-autocomplete
              @place="setPlace"
              v-model.trim="$v.organizerAddress.$model"
              :label="$t('label-edit-gathering-organizerAddress')"
              :required="true"
              :placeholder="$t('label-edit-gathering-organizerAddress-placeholder')"
            >
              <template>
                <span v-if="$v.organizerAddress.$dirty || $v.organizerAddressLatitude.$dirty">
                  <span class="m-form-group__error" v-if="!$v.organizerAddress.required">{{ $t('error-field-required') }}</span>
                  <span class="m-form-group__error" v-if="!$v.organizerAddressLatitude.required">{{ $t('error-lat-long-required') }}</span>
                </span>
              </template>
            </googlemap-autocomplete>
          </p>

          <p class="m-form-group">
            <label class="a-form-label" for="organizerPhone">
              {{ $t('label-edit-gathering-organizerPhone') }}<required-form-field />
              <span class="m-form-group__note m-form-group__note--small">{{ $t('detail-label-edit-gathering-organizerPhone') }}</span>
            </label>
            <input
              class="a-form-control"
              id="organizerPhone"
              v-model.lazy="$v.organizerPhone.$model"
              autocomplete="edit-gathering organizer-phone"
              :placeholder="$t('label-edit-gathering-organizerPhone-placeholder')"
            />
            <span v-if="$v.organizerPhone.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizerPhone.required">{{ $t('error-field-required') }}</span>
              <span class="m-form-group__error" v-if="!$v.organizerPhone.isPhone">{{ $t('error-phone-field-format') }}</span>
            </span>
          </p>

          <p class="m-form-group">
            <label class="a-form-label" for="facebookUrl">{{ $t('label-edit-gathering-organizerQuality') }}<required-form-field /></label>
            <span v-if="$v.organizerQuality.$dirty">
              <span class="m-form-group__error" v-if="!$v.organizerQuality.required">{{ $t('error-field-required') }}</span>
            </span>
            <span class="a-form-checkbox a-form-checkbox--block" v-for="quality in qualities" :key="quality.id">
              <input type="checkbox" :id="`pastEvent_${quality.id}`" :value="quality.id" v-model="$v.organizerQuality.$model" @change="e => organizerQualityChanged(e)" />
              <label :for="`pastEvent_${quality.id}`">{{ quality.text }}</label>
              <div v-if="quality.id === 4">
                <input
                  :disabled="disableOrganizerQualitySpecify"
                  class="a-form-control"
                  id="organizerQualitySpecify"
                  v-model.trim="$v.organizerQualitySpecify.$model"
                  autocomplete="edit-gathering organizer-quality-specify"
                />
                <span v-if="$v.organizerQualitySpecify.$dirty">
                  <span class="m-form-group__error" v-if="!$v.organizerQualitySpecify.requiredIfQualityOther">{{ $t('error-field-required') }}</span>
                </span>
              </div>
            </span>
          </p>
        </div>
      </div>
    </fieldset>

    <action-buttons
      :showSubmit="false"
      :isSubmitted="isSubmitted"
      :isAuthorized="isAuthorized"
      :errors="errors"
      @saveAndBack="saveAndBack"
      @saveAndQuit="saveAndQuit"
      @saveAndContinue="saveAndContinue"
      @previewGathering="previewGathering"
    />
  </s-form>
</template>

<script>
import SForm from '@/components/form/form'
import { required, email } from 'vuelidate/lib/validators'
import ActionButtons from '@/components/pages/gathering/edit-steps/action-buttons'
import GooglemapAutocomplete from '@/components/form/googlemap-autocomplete'
import RequiredFormField from '@/components/ui/required-form-field'

import GatheringService from '@/services/gathering'
import LoaderService from '@/services/loader'

import FormHelper from '@/helpers/form'

import { QualityList } from '@/mixins/form/quality-list'

const isPhone = value => FormHelper.isPhone(value)

const requiredIfQualityOther = function(value) {
  return value !== '' || this.disableOrganizerQualitySpecify
}

export default {
  components: {
    SForm,
    ActionButtons,
    GooglemapAutocomplete,
    RequiredFormField
  },
  mixins: [QualityList],
  props: {
    value: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      organizerName: this.value.OrganizerName !== null ? this.value.OrganizerName : '',
      organizationName: this.value.OrganizationName !== null ? this.value.OrganizationName : '',
      organizerEmail: this.value.OrganizerEmail !== null ? this.value.OrganizerEmail : '',
      organizerAddress: this.value.OrganizerAddress !== null ? this.value.OrganizerAddress : '',
      organizerAddressLatitude: this.value.OrganizerAddressLatitude !== null ? this.value.OrganizerAddressLatitude : '',
      organizerAddressLongitude: this.value.OrganizerAddressLongitude !== null ? this.value.OrganizerAddressLongitude : '',
      organizerAddressPostalcode: this.value.OrganizerAddressPostalcode !== null ? this.value.OrganizerAddressPostalcode : '',
      organizerAddressCity: this.value.OrganizerAddressCity !== null ? this.value.OrganizerAddressCity : '',
      organizerPhone: this.value.OrganizerPhone !== null ? this.value.OrganizerPhone : '',
      organizerQuality: this.value.OrganizerQuality,
      organizerQualitySpecify: this.value.OrganizerQualitySpecify !== null ? this.value.OrganizerQualitySpecify : '',
      isSubmitted: this.value.IsSubmitted !== null ? this.value.IsSubmitted : false,
      isAuthorized: this.value.IsPublish !== null ? this.value.IsPublish : false
    }
  },
  validations: {
    organizerName: {
      required
    },
    organizationName: {
      required
    },
    organizerEmail: {
      required,
      email
    },
    organizerAddress: {
      required
    },
    organizerAddressLatitude: {
      required
    },
    organizerPhone: {
      required,
      isPhone
    },
    organizerQuality: {
      required
    },
    organizerQualitySpecify: {
      requiredIfQualityOther
    }
  },
  computed: {
    gathering: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    disableOrganizerQualitySpecify: function() {
      return this.organizerQuality.indexOf(4) === -1
    },
    errors: function() {
      const errors = []

      if (this.$v.$invalid) {
        if (!this.$v.organizerName.required) {
          errors.push(this.$t('gathering-organizername-error-text'))
        }

        if (!this.$v.organizationName.required) {
          errors.push(this.$t('gathering-organizationname-error-text'))
        }

        if (!this.$v.organizerEmail.required) {
          errors.push(this.$t('gathering-organizeremail-error-text'))
        }

        if (!this.$v.organizerEmail.email) {
          errors.push(this.$t('gathering-organizeremailformat-error-text'))
        }

        if (!this.$v.organizerAddress.required) {
          errors.push(this.$t('gathering-organizeraddress-error-text'))
        } else if (!this.$v.organizerAddressLatitude.required) {
          errors.push(this.$t('gathering-organizeraddressformat-error-text'))
        }

        if (!this.$v.organizerPhone.required) {
          errors.push(this.$t('gathering-organizerphone-error-text'))
        }

        if (!this.$v.organizerPhone.isPhone) {
          errors.push(this.$t('gathering-organizerphoneformat-error-text'))
        }

        if (!this.$v.organizerQuality.required || !this.$v.organizerQualitySpecify.requiredIfQualityOther) {
          errors.push(this.$t('gathering-organizerquality-error-text'))
        }
      }

      return errors
    }
  },
  methods: {
    saveGathering: async function() {
      LoaderService.showLoader()

      const request = {
        gatheringId: this.gathering.Id
      }

      if (this.organizerName !== this.gathering.OrganizerName) {
        request.organizerName = { value: this.organizerName }
      }

      if (this.organizationName !== this.gathering.OrganizerName) {
        request.organizationName = { value: this.organizationName }
      }

      if (this.organizerEmail !== this.gathering.OrganizerEmail) {
        request.organizerEmail = { value: this.organizerEmail }
      }

      if (this.organizerAddress !== this.gathering.OrganizerAddress) {
        request.organizerAddress = { value: this.organizerAddress }
        request.organizerAddressLatitude = { value: this.organizerAddressLatitude }
        request.organizerAddressLongitude = { value: this.organizerAddressLongitude }
        request.organizerAddressPostalcode = { value: this.organizerAddressPostalcode }
        request.organizerAddressCity = { value: this.organizerAddressCity }
      }

      if (this.organizerPhone !== this.gathering.OrganizerPhone) {
        request.organizerPhone = { value: this.organizerPhone }
      }

      if (this.organizerQuality !== this.gathering.OrganizerQuality) {
        request.organizerQuality = { value: this.organizerQuality }
      }

      if (this.organizerQualitySpecify !== this.gathering.OrganizerQualitySpecify) {
        request.organizerQualitySpecify = { value: this.organizerQualitySpecify }
      }

      const response = await GatheringService.updateGathering(request)
      this.gathering = response
      LoaderService.hideLoader()
    },
    setPlace: function(place) {
      this.organizerAddressLongitude = place.geometry.location.lng()
      this.organizerAddressLatitude = place.geometry.location.lat()
      let vm = this

      place.address_components.forEach(function(c) {
        switch (c.types[0]) {
          case 'locality':
            vm.organizerAddressCity = c.long_name
            break
          case 'postal_code':
            vm.organizerAddressPostalcode = c.long_name
            break
        }
      })
    },
    organizerQualityChanged: function(e) {
      if (!e.target.checked) {
        if (e.target.value == 4) {
          this.organizerQualitySpecify = ''
          this.$v.$touch()
        }
      }
    },
    canSave: function(forceValidation = false) {
      if (this.isSubmitted || this.isAuthorized || forceValidation) {
        this.$v.$touch()
        return !this.$v.$invalid
      }
      return true
    },
    saveAndBack: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndBack')
      }
    },
    previewGathering: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('previewGathering')
      }
    },
    saveAndQuit: async function() {
      if (this.canSave()) {
        await this.saveGathering()
        this.$emit('saveAndQuit')
      }
    },
    saveAndContinue: async function() {
      if (this.canSave(true)) {
        await this.saveGathering()
        this.$emit('saveAndContinue')
      }
    }
  }
}
</script>
